import { render, staticRenderFns } from "./MerchantBankDetails.vue?vue&type=template&id=309dca1a&"
import script from "./MerchantBankDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports